$(document).ready(function(){

	$('.js-showmore').on('click', showAnswer);
	$('.js-showTab').on('click', showTabInfo);
	$('.js-videoOpen').on('click', videoOpen);
	$('.js-openForm').on('click', openForm);
	$('.js-menuMobOpen').on('click', menuMobOpen);
	$('.js-menuMobClose').on('click', menuMobClose);

	$(window).on('scroll load', function() {
         
		if ($(window).scrollTop() > 0) {
		  $('#header').addClass('scrolled');
		}
		else {
		  $('#header').removeClass('scrolled');  
		}
  });

  // if($("div").is(".features__content")){
  // 	featuresInit();
  // }
  
  // let height;

  // function featuresInit() {
  // 	let arr = [];

	 //  $('.features__item').each(function(id, itm) {
	 //  	arr.push($(itm).outerHeight())
	 //  })

	 //  height = Math.max.apply(null, arr);
	 //  $('.features__content').css('height', height)
  // }


	function openForm(e) {
		e.preventDefault();

		const targetModal = $(this).data('form')
		$(`#${targetModal}`).arcticmodal()
	}

	function menuMobOpen(e) {
		e.preventDefault();
		$('.js-menuMob').toggleClass('menu--active');
		$('#body').toggleClass('body--overflow-hiden')
	}

	function menuMobClose(e) {
		e.preventDefault();
		$('.js-menuMob').toggleClass('menu--active');
		$('#body').toggleClass('body--overflow-hiden')
	}

	function videoOpen(e) {
		e.preventDefault();

		$('.video__control').addClass('video__control--hide')
	}

	function showAnswer(e) {
		e.preventDefault();

		$(this).toggleClass('quest__item--active')
		// $(this).find('.quest__item-text').slideToggle()
	}	
	function showTabInfo(e) {
		e.preventDefault();
		let targetTab = $(this).attr('href');

		$(this).addClass('features__tabs-item--active').siblings('.features__tabs-item').removeClass('features__tabs-item--active')

		$(targetTab).addClass('features__item--active').siblings('.features__item').removeClass('features__item--active')
	}


})